'use client';
import * as React from 'react';
import { ErrorBoundary } from 'next/dist/client/components/error-boundary';
import { NotFoundComponent } from 'src/components/ui/error-component';

export const ErrorProvider = ({ children }: { children: React.ReactNode }) => (
  <ErrorBoundary errorComponent={NotFoundComponent}>{children}</ErrorBoundary>
);
